"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const privateChatInfoTranslation = {
    patients: "Patients",
    knowMeMoreBtn: "Know Me More",
    noQuestionsAnswered: " No questions are answered yet",
    about: "About",
    seeLess: "See Less",
    seeMore: "...See More",
};
exports.default = privateChatInfoTranslation;
